export default __webpack_public_path__ + "assets/wechatscan-login.dff215a2.png";